import { toastService, type ToastOptions } from "@/services/toastService";

export const useToast = () => {
  return {
    showToast: (
      message: string,
      type: "success" | "error" | "warning" | "info" = "info",
      options?: ToastOptions,
    ) => {
      return toastService[type](message, options);
    },
    dismissToast: (toastId?: string) => {
      toastService.dismiss(toastId);
    },
    success: (message: string, options?: ToastOptions) =>
      toastService.success(message, options),
    error: (message: string, options?: ToastOptions) =>
      toastService.error(message, options),
    warning: (message: string, options?: ToastOptions) =>
      toastService.warning(message, options),
    info: (message: string, options?: ToastOptions) =>
      toastService.info(message, options),
  };
};
